module.exports = __webpack_public_path__ + "cdf0c846490a71cf9caa31576268ae6e.pdf";